// import logo from './logo.svg';
import Dictionary from './Dictionary.js'
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          <Dictionary />
          <ul className='list-inline'> 
            <li className='list-item-inline'><a href="https://ornate-vacherin-913d97.netlify.app/">Website link</a></li>
            <li className='list-item-inline'> <a href="https://github.com/yve28/dicitionarysearch">Github</a></li>
          </ul>     
        </header>
      </div>
    </div>
  );
}

export default App;
